import { FC, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { scrollToId } from 'utils/helpers/scrollToId'

import { Hero } from '../Sections/Hero/Hero'
import { OpeningStepsSection } from './Sections/OpeningSteps/OpeningStepsSection'
import { stepsData } from './data'

import s from './PromoPageGe.module.scss'

export const PromoPageGe: FC = () => {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        scrollToId(location.hash)
      }, 100)
    }
  }, [location])

  return (
    <main className={s.main}>
      <Hero />
      <div className={s.openingSteps}>
      <OpeningStepsSection stepsData={stepsData} />
      </div>
   
    </main>
  )
}
